import { trackHideMessenger, trackShowMessenger } from './analytics';

export const trackIntercomEvents = () => {
  // oxlint-disable-next-line new-cap
  window?.Intercom('onShow', () => {
    trackShowMessenger();
  });
  // oxlint-disable-next-line new-cap
  window?.Intercom('onHide', () => {
    trackHideMessenger();
  });
};
